import img from '../../assets/emma-garcia.jpg';

const Emma = {
  name: 'Emma Garcia',
  bio: 'Emma is an Engineer. Every day, she speaks with users near and far to help them buy, replace, use, fix, and every so often, turn on Empower Plant’s state-of-the-art plant mood measurer (next time you consider gifting grandma with the latest technology, think of the support reps and buy her some art instead).',
  url: 'emma',
  img,
};

export default Emma;
